<template>
  <el-row>
    <el-col :lg="13">
      <el-form ref="form" label-position="top" :model="form" size="mini">
        <form-field label="Comece a retroalimentação digitando o nome do Ambiente">
          <u-select v-model="form.clientId" filterable remote reserve-keyword clearable placeholder="Entre com o nome"
            :remote-method="searchClients" :options="clients">
          </u-select>
        </form-field>

        <form-field label="Escolha o módulo para execução:">
          <u-select v-model="form.executionModule" placeholder="Escolha uma opção" clearable
            :options="EXECUTION_MODULES_OPTIONS">
          </u-select>
        </form-field>


        <form-field label="Enviar retro para o Mobile">
          <el-switch v-model="form.sentFeedToMobile"></el-switch>
        </form-field>

        <el-row>
          <form-field label="A partir da atividade:" :inside-row="false" :lg="8">
            <u-select v-model="form.activityId" filterable placeholder="Select" clearable :options="activities">
            </u-select>
          </form-field>

          <form-field label="Quero retroalimentar um:" :inside-row="false" :lg="8">
            <u-select v-model="form.entityTypeId" filterable placeholder="Escolha o tipo" clearable
              :options="entityTypesOptionsCustomized">
            </u-select>
          </form-field>

          <form-field label="Chamado de:" v-if="isCustomEntityChosen" :inside-row="false" :lg="8">
            <u-select v-model="form.entityId" filterable placeholder="Selecione..." clearable :options="customEntities">
            </u-select>
          </form-field>
        </el-row>

        <form-field label="Utilizando a operação:">
          <u-select v-model="form.operation" placeholder="Escolha a operação" clearable :disabled="disableOperation"
            :options="operationOptionsCustomized">
          </u-select>
        </form-field>


        <form-field class="executionMoment" label="Deve executar a retroalimentação:" v-if="isExecutionModuleMobile">
          <u-select v-model="form.executionMoment" placeholder="Escolha uma opção" clearable
            :options="EXECUTION_MOMENTS_OPTIONS">
          </u-select>
        </form-field>


        <form-field label="Ordenar itens por execução" v-if="isAtItemFinishing">
          <el-switch v-model="form.orderItemsByExecution"></el-switch>
        </form-field>


        <card-form class="criterias" v-if="enableCriteriaForm" :title="titleCriteriaForm">
          <div slot="body">
            <el-row v-for="(criteriaField, index) in form.criteriaFields" :key="index">
              <el-form label-position="top" label-width="100px" size="mini">
                <el-col class="numeral" :lg="1">
                  <span>{{ index + 1 }}.</span>
                </el-col>
                <el-col :lg="10">
                  <el-form-item :label="labelCriteriaField">
                    <el-cascader placeholder="Escolha o valor" v-model="criteriaField.sectionAndFieldIds"
                      :options="sectionCascader" clearable filterable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col class="criterias__equals-signal" :lg="2" v-if="showFieldsWhenIsNotDeleteOperation">
                  <span>=</span>
                </el-col>
                <el-col :lg="9" v-if="showFieldsWhenIsNotDeleteOperation">
                  <el-form-item label="Ao campo da entidade">
                    <el-select v-model="criteriaField.field" placeholder="Escolha o campo" clearable value-key="field"
                      filterable>
                      <el-option-group v-for="group in groupCriteriaFieldsScreen" :key="group.fieldType"
                        :label="group.fieldType">
                        <el-option v-for="item in group.fields" :key="item.field"
                          :label="formatLabelOption(item.cac_descricao, item.field)" :value="item"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :lg="2" v-if="showFieldsWhenIsNotDeleteOperation">
                  <el-form-item>
                    <el-button class="form__removeBtn" icon="el-icon-delete"
                      @click="removeCriteriaField(index)"></el-button>
                  </el-form-item>
                </el-col>
                <el-col>
                  <hr v-if="form.criteriaFields.length != (index + 1)">
                </el-col>
              </el-form>
            </el-row>
          </div>
          <div slot="footer" v-if="showFieldsWhenIsNotDeleteOperation">
            <el-button icon="el-icon-plus" size="mini" @click="addCriteriaField">Adicionar</el-button>
          </div>
        </card-form>

        <card-form class="retroalimentation" v-if="enableRetroalimentationForm" title="Retroalimentar:">
          <div slot="body">
            <el-row v-for="(rowRetro, index) in form.retroalimentationFields" :key="index">
              <el-form label-position="top" label-width="100px" size="mini">
                <el-col class="numeral" :lg="1">
                  <span>{{ index + 1 }}.</span>
                </el-col>

                <el-col :lg="8">
                  <el-form-item label="Do campo da seção">
                    <el-cascader placeholder="Escolha o campo da seção" v-model="rowRetro.sectionAndFieldIds"
                      :options="sectionCascader" clearable filterable></el-cascader>
                  </el-form-item>
                </el-col>

                <el-col :lg="4">
                  <el-form-item label="Sem valor nulo">
                    <el-switch v-model="rowRetro.mustDeleteToFieldValueWhenFromSectionFieldIsNull"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :lg="7">
                  <el-form-item label="Para o campo">
                    <el-select v-model="rowRetro.field" placeholder="Escolha o campo" clearable filterable
                      value-key="toFieldId" :disabled="isTrashBtnDisabled(rowRetro.field.toFieldId)">
                      <el-option-group v-for="group in groupRetroFieldsScreen" :key="group.fieldType"
                        :label="group.fieldType">
                        <el-option v-for="item in group.fields" :key="item.toFieldId"
                          :label="formatLabelOption(item.cac_descricao, item.toFieldId)" :value="item"></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :lg="1">
                  <el-form-item>
                    <el-button class="form__removeBtn" icon="el-icon-delete"
                      :disabled="isTrashBtnDisabled(rowRetro.field.toFieldId)"
                      @click="removeRetroalimentationaField(index)"></el-button>
                  </el-form-item>
                </el-col>
                <el-col>
                  <hr v-if="form.retroalimentationFields.length != (index + 1)">
                </el-col>
              </el-form>
            </el-row>
          </div>
          <div slot="footer">
            <el-button icon="el-icon-plus" size="mini" @click="addRetroalimentationField(null)">Adicionar</el-button>
          </div>
        </card-form>
      </el-form>
    </el-col>
    <el-col :lg="11">
      <json-retro :form="form" @json-updated="setJSON"></json-retro>
      <el-row class="buttons-bar">
        <copy-json-button class="button copy-button">
        </copy-json-button>
        <el-button class="button save-button" type="success" @click="confirmSave"
          :disabled="hasMediaAndDataTypeOnInsert">
          Salvar
        </el-button>
      </el-row>
      <el-row class="buttons-bar error">
        <ul>
          <li v-if="hasMediaAndDataTypeOnInsert">Não é possível inserir com campos mistos de dados e mídia!</li>
          <span v-if="hasMediaAndDataTypeOnInsert">Altere a operação para Inserir/Atualizar.</span>
        </ul>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import UmovComponents from "umovme-vuejs-components"
import sectionService from "@/services/section";
import activityService from "@/services/activity";
import entityService from "@/services/entity";
import clientService from "@/services/client";

import CriteriaScreenFieldsLogic from "@/mixins/CriteriaScreenFieldsLogic";

import _ from "lodash";

import JsonRetro from "@/views/JSON";
import FormField from "@/components/FormField";
import CardForm from "@/components/CardForm";
import CopyJsonButton from "@/components/CopyJsonButton";
import ValidationMixin from "@/views/EditValidationMixin"
import { OPERATION, ENTITY_TYPES } from "@/views/EditConstants"
import {
  OPERATION_OPTIONS,
  ENTITY_TYPES_OPTIONS,
  EXECUTION_MODULES_OPTIONS,
  EXECUTION_MOMENTS_OPTIONS
} from "@/views/EditFieldOptions"

export default {
  name: "Edit",
  components: {
    USelect: UmovComponents.USelect,
    UButton: UmovComponents.UButton,
    CardForm,
    FormField,
    JsonRetro,
    CopyJsonButton
  },
  mixins: [ValidationMixin, CriteriaScreenFieldsLogic],
  data() {
    return {
      form: {
        executionModule: "",
        sentFeedToMobile: false,
        orderItemsByExecution: false,
        executionMoment: null,
        entity: "",
        entityId: null,
        operation: null,

        entityTypeId: null,
        clientId: null,
        activityId: null
      },
      loadingClients: false,
      clients: [],
      customEntities: [],
      activities: [],
      sectionCascader: [],
      disableOperation: false,

      EXECUTION_MODULES_OPTIONS,
      EXECUTION_MOMENTS_OPTIONS,
      json: []
    };
  },
  created() {
    this.populateActivitiesField(this.form.clientId);
  },
  computed: {
    hasMediaType() {
      return this.fieldsFromSelected.find(fieldType => fieldType == "media") ? true : false
    },
    hasDataType() {
      return this.fieldsFromSelected.find(fieldType => fieldType == "data") ? true : false
    },
    hasMediaAndDataTypeOnInsert() {
      return this.hasMediaType && this.hasDataType && this.isInsertOperation
    },
    fieldsSelected() {
      var fieldsSelected = []
      this.form.retroalimentationFields.forEach(function (fields) {
        if (fields.field)
          fieldsSelected.push(fields.field)
      })
      return fieldsSelected
    },
    entityTypesOptionsCustomized() {
      if (this.isExecutionModuleNotMobile) {
        return ENTITY_TYPES_OPTIONS.filter(it =>
          [ENTITY_TYPES.CUSTOM_ENTITY.ID, ENTITY_TYPES.SERVICE_LOCAL_ITEM.ID, ENTITY_TYPES.SERVICE_LOCAL.ID].includes(it.value)
        )
      }
      return ENTITY_TYPES_OPTIONS
    },
    chosenEntityType() {
      if (!this.form.entityTypeId) return null;
      return (
        ENTITY_TYPES_OPTIONS.find(
          entityType => entityType.value == this.form.entityTypeId
        ) || null
      );
    },
    operationOptionsCustomized() {
      return OPERATION_OPTIONS.filter(operation => operation.value == OPERATION.DELETE
        ? this.isDeleteOperationEnabled
        : true
      )
    },
    labelCriteriaField() {
      return this.showFieldsWhenIsNotDeleteOperation ? "Ao campo da entidade" : "Com base no campo"
    },
    titleCriteriaForm() {
      return this.showFieldsWhenIsNotDeleteOperation ? "Com os seguintes critérios para a atualização do(s) registro(s):" : "Excluir item"
    },
    fieldsFromSelected() {
      var fieldsTypes = []
      this.form.retroalimentationFields.forEach(function (fields) {
        if (fields.field)
          fieldsTypes.push(fields.field.fromSectionFieldType)
      })
      return fieldsTypes
    }
  },
  watch: {
    "form.clientId"(clientId) {
      this.populateActivitiesField(clientId);
    },
    "form.activityId"(activityId) {
      this.populateSectionCascader(activityId);
    },
    "form.executionModule"() {
      if (this.isExecutionModuleNotMobile) {
        this.form.entityTypeId = ENTITY_TYPES.CUSTOM_ENTITY.ID;
      } else {
        this.form.entityTypeId = null;
      }
    },
    "form.entityTypeId"() {
      this.clearCustomEntityRelations();
      if (!_.isEmpty(this.chosenEntityType)) {
        this.form.entity = this.chosenEntityType.slug;
        if (this.chosenEntityType.slug === ENTITY_TYPES.CUSTOM_ENTITY.SLUG) {
          this.disableOperation = false;
          this.populateCustomEntities();
          return;
        }
        if (this.chosenEntityType.slug === ENTITY_TYPES.SERVICE_LOCAL_ITEM.SLUG) {
          this.disableOperation = false;
          this.getEntityFields();
          return;
        }
        this.setUpdateOperationAndDisableField();
        this.getEntityFields();
      }
    },
    "form.entityId"() {
      if (!this.form.entityId) return;
      this.getEntityFields();
    },
    "form.executionMoment"() {
      if (!this.form.executionMoment)
        this.form.executionMoment = null
    },
    hasOperationsToShowCriteriaForm(enabled) {
      if (enabled) {
        this.clearCriteriaForm();
        this.addCriteriaField();
      }
    },
    isDeleteOperationChosen(chosen) {
      if (chosen) {
        this.clearRetroAlimentationForm();
      }
    },
    enableRetroalimentationForm(enabled) {
      if (enabled) {
        this.clearRetroAlimentationForm();
        this.addDefaultFieldsToRetroalimentation();
        this.addRetroalimentationField();
      }
    }
  },
  methods: {
    setJSON(json) {
      this.json = json
    },
    formatLabelOption(description, code) {
      return `${description} (${code})`;
    },
    setUpdateOperationAndDisableField() {
      this.form.operation = OPERATION.UPDATE;
      this.disableOperation = true;
    },
    clearCustomEntityRelations() {
      this.form.entityId = null;
      this.form.entity = "";
    },
    clearCriteriaForm() {
      this.form.criteriaFields = [];
    },
    clearRetroAlimentationForm() {
      this.form.retroalimentationFields = [];
    },
    async confirmSave() {
      if (!this.isFormValid()) return

      try {
        const resp = await activityService.getJson(this.form.activityId);
        const json = resp.data
        if (json && json.length > 0) {
          const confirmed = await this.$confirm("Já há uma retroalimentação na atividade, deseja substituí-la?", "Aviso!", {
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
            type: "warning"
          })
          if (confirmed == "confirm")
            this.save()
        } else {
          this.save()
        }
      } catch (e) {
        if (e !== "cancel") {
          this.$message({
            message: "Houve algum erro ao salvar a retro ou ao verificar se há um json",
            type: "error"
          });
        }
      }
    },
    async save() {
      try {
        let reqData = { clientId: this.form.clientId, activityId: this.form.activityId, json: JSON.stringify(this.json) }
        console.log(reqData)
        await activityService.saveJson(reqData);
        this.$message({
          message: "Retroalimentação salva com sucesso!",
          type: "success"
        });
      } catch (e) {
        this.$message({
          message: "Não foi possível salvar a Retroalimentação.",
          type: "error"
        });
      }
    },
    async searchClients(clientName) {
      if (clientName !== "") {
        let resp = await clientService.get(clientName);
        this.clients = resp.data.map(it => ({ value: it.cli_codigo, label: it.cli_alias }));
      } else {
        this.clients = [];
      }
    },
    async populateActivitiesField(clientId) {
      if (clientId) {
        let resp = await activityService.get(clientId);
        this.activities = resp.data.map(it => ({
          label: this.formatLabelOption(it.pes_descricao, it.pes_codigo),
          value: it.pes_codigo
        }));
      }
    },
    async populateCustomEntities() {
      let resp = await entityService.getEntities(this.form.clientId);
      this.customEntities = resp.data.map(it => ({
        label: this.formatLabelOption(it.cad_descricao, it.cad_codigo),
        value: it.cad_codigo
      }));
    },
    async populateSectionCascader(activityId) {
      let resp = await sectionService.get(activityId);
      this.mountSectionFieldsCascader(resp.data);
    },
    mountSectionFieldsCascader(sections) {
      this.sectionCascader = [];
      _.each(sections, async section => {
        let sectionCascader = sectionService.convertSectionToCascader(section);

        let fields = await this.getSectionFields(sectionCascader);
        let fieldsCascader = sectionService.convertFieldsToCascader(fields);

        this.sectionCascader.push(
          sectionService.mergeSectionAndFieldsCascader(
            sectionCascader,
            fieldsCascader
          )
        );
      });
    },
    async getSectionFields(section) {
      let resp = await sectionService.fields(section.value);

      return resp.data.map(section => {
        section.spq_codigo = Number(section.spq_codigo);
        return section;
      });
    }
  }
};
</script>

<style lang="scss">
.buttons-bar {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.copy-button {
  margin-right: 5px;
}

.button {
  margin-right: 5px;
}

hr {
  border: 0.5px solid #ebeef5;
}

.el-form--label-top .el-form-item__label {
  padding: 0px !important;
}

.el-card {
  margin-top: 10px;
}

.el-form-item__label {
  padding: 0px !important;
}

.el-form-item {
  margin-bottom: 8px !important;
}

.el-select,
.el-cascader {
  width: 95%;
}

.form__removeBtn {
  margin-top: 28px !important;
}

.el-card__body {
  padding: 10px !important;
}

.criterias {
  & &__equals-signal {
    margin-top: 33px;
    text-align: center;
    padding-right: 17px;
  }
}

.numeral {
  text-align: center;
  margin-top: 2px;
}

.error {
  color: red;
}
</style>